// First Created - 11 Aug 2025
// Author - Atul Pandey
// Purpose - To help get / create/ update / delete user mission goals - personal and shared
import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userMissionGoalsAdapter = createEntityAdapter({})

const initialState = userMissionGoalsAdapter.getInitialState()

export const userMissionGoalsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserMissionGoals: builder.query({
            query: () => ({
                url: '/userMissionGoals/getUserMissionGoals',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedUserMissionGoals = responseData.map(userMissionGoal => {
                    userMissionGoal.id = userMissionGoal._id
                    return userMissionGoal
                })
                return userMissionGoalsAdapter.setAll(initialState, loadedUserMissionGoals)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'UserMissionGoal', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'UserMissionGoal', id}))
                    ]
                } else {
                    return [ { type: 'UserMissionGoal', id: 'LIST'}]
                }
            },
        }),
        createNewUserMissionGoal: builder.mutation({
            query: initialUserMissionGoal => ({
                url: '/userMissionGoals/createNewUserMissionGoal',
                method: 'POST',
                body: {...initialUserMissionGoal,}
            }),
            invalidatesTags: [
                { type: 'UserMissionGoal', id: "LIST" }
            ] 
        }),
        updateUserMissionGoal: builder.mutation({
            query: initialUserMissionGoal => ({
                url: '/userMissionGoals/updateUserMissionGoal',
                method: 'PATCH',
                body: {...initialUserMissionGoal,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'UserMissionGoal', id: arg.id },
                { type: 'UserMissionGoal', id: 'LIST' }
            ],
        }),
        deleteUserMissionGoal: builder.mutation({
            query: (deletionPayload) => ({
                url: '/userMissionGoals/deleteUserMissionGoal',
                method: 'DELETE',
                body: deletionPayload
            }),
            // query: ({id}) => ({
            //     url: '/userMissionGoals/deleteUserMissionGoal',
            //     method: 'DELETE',
            //     body: {id}
            // }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserMissionGoal', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetUserMissionGoalsQuery,
    useCreateNewUserMissionGoalMutation,
    useUpdateUserMissionGoalMutation,
    useDeleteUserMissionGoalMutation,
} = userMissionGoalsApiSlice

// returns the query result object
export const selectUserMissionGoalResult = userMissionGoalsApiSlice.endpoints.getUserMissionGoals.select()

// create memoized selector
const selectUserMissionGoalsData = createSelector(
    selectUserMissionGoalResult,
    userMissionGoalResult => userMissionGoalResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserMissionGoals,
    selectById: selectUserMissionGoalById,
    selectIds: selectUserMissionGoalIds,
} = userMissionGoalsAdapter.getSelectors(state => selectUserMissionGoalsData(state) ?? initialState)